import { TrendingUp, DollarSign, Receipt } from "lucide-react";
import { AppLayout } from "@/components/layout/AppLayout";
import { StatCard } from "@/components/shared/StatCard";
import { RevenueTable } from "@/components/revenue/RevenueTable";
import { useSubscriptionStats } from "@/hooks/useSubscriptions";
import { formatCurrency } from "@/utils/format";

const RevenueStats = () => {
  const { data, isLoading } = useSubscriptionStats();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="bg-card rounded-card border border-border p-5 animate-pulse h-24"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
      <StatCard
        title="Total Revenue"
        value={formatCurrency(data?.totalRevenue ?? 0)}
        subtitle="All time collected"
        icon={DollarSign}
        variant="success"
      />
      <StatCard
        title="This Month"
        value={formatCurrency(data?.monthRevenue ?? 0)}
        subtitle="Revenue this billing cycle"
        icon={TrendingUp}
        variant="info"
      />
      <StatCard
        title="Paid Transactions"
        value={data?.transactionCount ?? 0}
        subtitle="Successful payments"
        icon={Receipt}
        variant="default"
      />
    </div>
  );
};

export const RevenuePage = () => (
  <AppLayout title="Revenue">
    <RevenueStats />
    <div className="bg-card rounded-card border border-border">
      <div className="px-5 py-4 border-b border-border">
        <h2 className="font-semibold text-foreground">Payment Transactions</h2>
        <p className="text-sm text-muted-foreground mt-0.5">
          Every subscription payment recorded as a revenue entry
        </p>
      </div>
      <div className="p-4">
        <RevenueTable />
      </div>
    </div>
  </AppLayout>
);

export default RevenuePage;
